// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"a4f7e174","401":"22182e80","787":"5595b94f"}[chunkId] + ".chunk.js";
};